export const CALENDAR_VIEW_OPTIONS = {
  month: 'dayGridMonth',
  week: 'dayGridWeek',
  day: 'dayGridDay',
};
